import LateLoansLookup from '../data-deletion/LateLoansLookup';

/** Eliminar clientes: por ahora solo consulta los préstamos con atraso de las rutas elegidas. */
const ClientDeletion = () => <LateLoansLookup titleKey="dataDeletion.titleClients" />;

export default ClientDeletion;
